// @givmo/app-charity — the charity's own logo for the organization QR design editor (FCM-WEB4).
//
// The editor's "{Org} logo" choice draws the organization's logo from its HOST (`GET …/qr-design`
// says only whether a logo exists). This host already reads it: the Profile page's Details tab and its
// public header load the charity profile, so this is the same query key and cache entry — a QR page
// opened after the Profile page reads nothing new. Null while loading, and for a charity with no logo.

import { useQuery } from '@tanstack/react-query';
import { charityAdminGetCharityProfileOptions } from '@givmo/api-client/query';
import { useActiveOrg } from '../../org/active-org-context';

export function useCharityLogoSrc(): string | null {
  const { activeCharityId } = useActiveOrg();
  const charityId = activeCharityId ?? '';
  const profile = useQuery({
    ...charityAdminGetCharityProfileOptions({ path: { charity_id: charityId } }),
    enabled: charityId.length > 0,
  });
  return profile.data?.profile?.logo_url ?? null;
}
